"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vizzly = void 0;
const MissingRequiredVizzlyQueryEngineApi_1 = require("../errors/MissingRequiredVizzlyQueryEngineApi");
const DashboardRepository_1 = require("./DashboardRepository");
const GlobalLibraryRepository_1 = require("./GlobalLibraryRepository");
const DashboardManager_1 = require("./DashboardManager");
const GlobalLibraryManager_1 = require("./GlobalLibraryManager");
class Vizzly {
    constructor(APIs, implementationStrategy) {
        this.APIs = APIs;
        this.implementationStrategy = implementationStrategy;
        this.dashboardManager = new DashboardManager_1.DashboardManager(this);
        this.dashboardRepository = new DashboardRepository_1.DashboardRepository(this);
        this.globalLibraryRepository = new GlobalLibraryRepository_1.GlobalLibraryRepository(this);
        this.globalLibraryManager = new GlobalLibraryManager_1.GlobalLibraryManager(this);
    }
    getAPIs() {
        if (this.implementationStrategy.shouldPersistViaQueryEngine() && !this.APIs.vizzlyQueryEngineApi) {
            throw new MissingRequiredVizzlyQueryEngineApi_1.MissingRequiredVizzlyQueryEngineApi('Strategy is to persist via a query engine. However no query engine API was provided.');
        }
        return this.APIs;
    }
    getVizzlyAppApi() {
        return this.getAPIs().vizzlyAppApi;
    }
    getVizzlyQueryEngineAPI() {
        return this.getAPIs().vizzlyQueryEngineApi;
    }
    getVizzlyAPI() {
        return this.getAPIs().vizzlyApi;
    }
    getDashboardRepository() {
        return this.dashboardRepository;
    }
    getGlobalLibraryRepository() {
        return this.globalLibraryRepository;
    }
    getDashboardManager() {
        return this.dashboardManager;
    }
    getGlobalLibraryManager() {
        return this.globalLibraryManager;
    }
}
exports.Vizzly = Vizzly;
